import React, { useState, useEffect } from "react";
import {
  useParams,
  useLocation,
  useSearchParams,
  useNavigate,
} from "react-router-dom";
import { toast } from "react-toastify";
import dayjs from "dayjs";
import { getUserInfo } from "../../../../services/AuthService";
import {
  getResultById,
  getExamResultsRanking,
} from "../../../../services/TestService";
import AnswerConditionModal from "../../../common/AnswerConditionModal";
import VisibilityIcon from "@mui/icons-material/Visibility";

const ExamResultPage = () => {
  const location = useLocation();
  const [resultData, setResultData] = useState(null);
  const [loading, setLoading] = useState(true);
  const { examId } = useParams();
  const [searchParams] = useSearchParams();
  const examRoomId = searchParams.get("examRoomId");
  const uniqueId = searchParams.get("uniqueId");
  const title = searchParams.get("title");
  const navigate = useNavigate();
  const [isAnswer, setIsAnswer] = useState(false);
  const [exam, setExam] = useState(null);
  const [rankingData, setRankingData] = useState([]);
  const [topThreeUsers, setTopThreeUsers] = useState([]);
  const [loadingRanking, setLoadingRanking] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const [pagination, setPagination] = useState({
    currentPage: 1,
    totalPages: 1,
    totalResults: 0,
    limit: 10,
    hasNext: false,
    hasPrev: false,
  });
  const [showAnswerConditionModal, setShowAnswerConditionModal] =
    useState(false);

  function isNowInRangeCompletedDate(startTime, endTime, completedDate) {
    if (!completedDate || !startTime || !endTime) {
      return false;
    }
    const now = new Date(completedDate); // thời gian hiện tại
    const start = new Date(startTime);
    const end = new Date(endTime);

    return now >= start && now <= end;
  }

  function isNowInRange(startTime, endTime) {
    if (!startTime || !endTime) {
      return false;
    }
    const now = new Date(); // thời gian hiện tại
    const start = new Date(startTime);
    const end = new Date(endTime);

    return now >= start && now <= end;
  }

  useEffect(() => {
    const fetchExamResult = async () => {
      try {
        const response = await getResultById(examId);
        if (response && response?.data) {
          const exam = response?.data;
          setExam(exam);
          setIsAnswer(exam?.isAnswer);
          let subjects = [];

          const totalScore = exam?.totalScore;

          const mockTestResult = {
            subjects,
            overallScore: totalScore || 0,
            maxOverallScore: exam.maxOverallScore || 0,
          };

          setResultData(mockTestResult);
        }
      } catch (error) {
        console.error("Error fetching exam result:", error);
        toast.error("Lỗi khi tải kết quả thi");
        navigate(`/practice-room`);
      } finally {
        setLoading(false);
      }
    };
    fetchExamResult();
  }, [examId]);

  // useEffect(() => {
  //   const fetchRankingData = async () => {
  //     try {
  //       setLoadingRanking(true);
  //       const response = await getExamResultsRanking(examId, currentPage, 10);
  //       console.log(response);
  //       if (response && response?.data) {
  //         setRankingData(response.data);

  //         // Lưu top 3 chỉ khi load trang 1
  //         if (currentPage === 1) {
  //           const top1 = response.data.find((user) => user.rank === 1);
  //           const top2 = response.data.find((user) => user.rank === 2);
  //           const top3 = response.data.find((user) => user.rank === 3);
  //           const topUsers = [top1, top2, top3].filter(Boolean);
  //           if (topUsers.length > 0) {
  //             setTopThreeUsers(topUsers);
  //           }
  //         }

  //         if (response.pagination) {
  //           setPagination(response.pagination);
  //         }
  //       }
  //     } catch (error) {
  //       console.error("Error fetching ranking data:", error);
  //       toast.error("Lỗi khi tải bảng xếp hạng");
  //       navigate(`/practice-room`);
  //     } finally {
  //       setLoadingRanking(false);
  //     }
  //   };

  //   if (examId) {
  //     fetchRankingData();
  //   }
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [examId, currentPage]);

  // if (!resultData) {
  //   return (
  //     <div className="min-h-screen flex items-center justify-center bg-gray-50">
  //       <div className="text-center">
  //         <p className="text-gray-600">Không tìm thấy kết quả thi</p>
  //       </div>
  //     </div>
  //   );
  // }

  const handleViewAnswer = (subjectType) => {
    window.open(
      `/exam-answer/${examId}?examRoomId=${examRoomId}&subject=${subjectType}&uniqueId=${uniqueId}`,
      "_blank"
    );
  };

  const getTitle = () => {
    let title = "";
    if (exam?.type === "TSA") {
      title = "KẾT QUẢ BÀI THI ĐÁNH GIÁ TƯ DUY TSA";
    } else if (exam?.type === "THPT") {
      title = "KẾT QUẢ BÀI THI THỬ THPT QUỐC GIA";
    } else if (exam?.type === "HSA") {
      title = "KẾT QUẢ BÀI THI ĐÁNH GIÁ NĂNG LỰC HSA";
    }
    return title;
  };

  // Helper functions for ranking display
  const getAvatarColor = (index) => {
    const colors = [
      "avatar-red",
      "avatar-purple",
      "avatar-blue",
      "avatar-gray",
    ];
    return colors[index % colors.length];
  };

  const getUserInitial = (fullName) => {
    if (!fullName) return "U";
    const words = fullName.trim().split(" ");
    return words[words.length - 1].charAt(0).toUpperCase();
  };

  // Component để hiển thị avatar hoặc initial
  const UserAvatar = ({ user, className, index = 0 }) => {
    const hasAvatar =
      user?.userId?.avatar && user?.userId?.avatar.trim() !== "";

    if (hasAvatar) {
      return (
        <div className={className}>
          <img
            src={user.userId.avatar}
            alt={user.userId.fullName || "User"}
            className="w-full h-full object-cover rounded-full"
            onError={(e) => {
              // Fallback nếu ảnh bị lỗi
              e.target.style.display = "none";
              e.target.nextSibling.style.display = "flex";
            }}
          />
          <div
            className={`${className} ${getAvatarColor(index)}`}
            style={{ display: "none" }}
          >
            {getUserInitial(user.userId.fullName)}
          </div>
        </div>
      );
    }

    return (
      <div className={`${className} ${getAvatarColor(index)}`}>
        {getUserInitial(user.userId.fullName)}
      </div>
    );
  };

  const getShieldClass = (rank) => {
    if (rank === 1) return "shield first";
    if (rank === 2) return "shield second";
    if (rank === 3) return "shield third";
    return "";
  };

  // Helper functions for pagination
  const handlePageChange = (newPage) => {
    if (newPage >= 1 && newPage <= pagination.totalPages) {
      setCurrentPage(newPage);
    }
  };

  const renderPageNumbers = () => {
    const pages = [];
    const maxVisiblePages = 5;
    let startPage = Math.max(1, currentPage - Math.floor(maxVisiblePages / 2));
    let endPage = Math.min(
      pagination.totalPages,
      startPage + maxVisiblePages - 1
    );

    if (endPage - startPage < maxVisiblePages - 1) {
      startPage = Math.max(1, endPage - maxVisiblePages + 1);
    }

    for (let i = startPage; i <= endPage; i++) {
      pages.push(i);
    }

    return pages;
  };

  return (
    <>
      <link
        rel="stylesheet"
        href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.4.0/css/all.min.css"
      />

      <style jsx>{`
        * {
          margin: 0;
          padding: 0;
          box-sizing: border-box;
          font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto,
            Oxygen, Ubuntu, Cantarell, "Open Sans", "Helvetica Neue", sans-serif;
        }

        .container {
          max-width: 1250px;
          margin: 0 auto;
          padding: 0 15px;
          display: flex;
          gap: 20px;
        }

        .main-container {
          flex: 1;
        }

        /* Header */
        header {
          background-color: #fff;
          box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
          padding: 12px 0;
          position: sticky;
          top: 0;
          z-index: 100;
        }

        .header-container {
          display: flex;
          align-items: center;
          justify-content: space-between;
          max-width: 1200px;
          margin: 0 auto;
          padding: 0 15px;
        }

        .logo {
          display: flex;
          align-items: center;
        }

        .logo-icon {
          width: 36px;
          height: 36px;
          background-color: #2e8bc0;
          border-radius: 8px;
          display: flex;
          align-items: center;
          justify-content: center;
          color: white;
          font-weight: bold;
          font-size: 20px;
        }

        .search-bar {
          display: flex;
          align-items: center;
          background-color: #f0f2f5;
          border-radius: 20px;
          padding: 8px 15px;
          width: 300px;
          margin-left: 15px;
        }

        .search-bar input {
          border: none;
          background: transparent;
          outline: none;
          width: 100%;
          margin-left: 8px;
          font-size: 14px;
        }

        .nav-icons {
          display: flex;
          align-items: center;
          gap: 20px;
        }

        .nav-icon {
          color: #65676b;
          font-size: 20px;
          text-decoration: none;
          transition: color 0.2s;
        }

        .nav-icon:hover {
          color: #1877f2;
        }

        .auth-buttons {
          display: flex;
          align-items: center;
        }

        .auth-link {
          color: #1877f2;
          text-decoration: none;
          font-size: 14px;
          margin-right: 15px;
          display: flex;
          align-items: center;
          transition: color 0.2s;
        }

        .auth-link:hover {
          color: #166fe5;
        }

        .auth-link i {
          margin-right: 5px;
        }

        .login-btn {
          background-color: #1877f2;
          color: white;
          border: none;
          border-radius: 4px;
          padding: 8px 16px;
          font-weight: 500;
          cursor: pointer;
          transition: background-color 0.2s;
        }

        .login-btn:hover {
          background-color: #166fe5;
        }

        /* Breadcrumb */
        .breadcrumb {
          display: flex;
          align-items: center;
          padding: 15px 0;
          font-size: 14px;
        }

        .breadcrumb a {
          color: #65676b;
          text-decoration: none;
          display: flex;
          align-items: center;
          transition: color 0.2s;
        }

        .breadcrumb a:hover {
          color: #1877f2;
        }

        .breadcrumb span {
          margin: 0 8px;
          color: #65676b;
        }

        /* Main Content */
        .main-content {
          background-color: #fff;
          border-radius: 8px;
          box-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
          margin-bottom: 20px;
          padding: 20px;
        }

        .page-title {
          color: #db3b6d;
          font-size: 28px;
          margin-bottom: 20px;
          text-align: center;
        }

        /* Result Cards */
        .result-grid {
          display: grid;
          grid-template-columns: 1fr 1fr;
          gap: 20px;
          margin-bottom: 20px;
        }

        .overall-score-card {
          border-radius: 12px;
          padding: 30px;
          color: white;
          text-align: center;
        }

        .overall-score-title {
          font-size: 20px;
          font-weight: 600;
          margin-bottom: 5px;
        }

        .overall-score-subtitle {
          font-size: 16px;
          opacity: 0.9;
          margin-bottom: 20px;
          font-style: italic;
        }

        .overall-score-number {
          font-size: 80px;
          font-weight: bold;
          line-height: 1;
          margin-bottom: 10px;
        }

        .overall-score-range {
          font-size: 20px;
          font-weight: 500;
        }

        .subjects-section {
          display: flex;
          flex-direction: column;
          gap: 15px;
        }

        .subjects-title {
          font-size: 20px;
          font-weight: 600;
          color: #2c3e50;
          margin-bottom: 10px;
        }

        .subjects-subtitle {
          font-style: italic;
          color: #7f8c8d;
        }

        .subject-card {
          border-radius: 10px;
          padding: 20px;
          color: white;
          display: flex;
          align-items: center;
          gap: 15px;
        }

        .subject-score {
          background: rgba(255, 255, 255, 0.2);
          border-radius: 8px;
          padding: 15px;
          text-align: center;
          min-width: 80px;
        }

        .subject-score-number {
          font-size: 36px;
          font-weight: bold;
          display: block;
          line-height: 1;
        }

        .subject-score-range {
          font-size: 14px;
          opacity: 0.9;
          margin-top: 5px;
        }

        .subject-info {
          flex: 1;
        }

        .subject-name {
          font-size: 18px;
          font-weight: 600;
          margin-bottom: 5px;
        }

        .subject-name-en {
          font-size: 15px;
          opacity: 0.9;
          font-style: italic;
        }

        /* Info Section */
        .info-section {
          background-color: #fff;
          border-radius: 8px;
          box-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
          padding: 20px;
          margin-bottom: 20px;
        }

        .info-item {
          display: flex;
          align-items: center;
          padding: 12px 0;
          flex-wrap: wrap;
          gap: 8px;
        }

        .info-item:last-child {
          border-bottom: none;
        }

        .info-label {
          font-size: 16px;
          font-weight: 500;
          color: #2c3e50;
          width: 140px;
          flex-shrink: 0;
        }

        .info-label-en {
          font-size: 15px;
          font-style: italic;
          color: #7f8c8d;
          width: 140px;
          flex-shrink: 0;
        }

        .info-value {
          font-size: 16px;
          padding: 8px 16px;
          border-radius: 6px;
          font-weight: 600;
          color: #2c3e50;
          margin-left: auto;
          min-width: 0;
          word-break: break-word;
        }

        @media (max-width: 768px) {
          .info-item {
            flex-direction: column;
            align-items: flex-start;
            gap: 4px;
          }

          .info-label,
          .info-label-en {
            width: 100%;
            font-size: 16px;
          }

          .info-value {
            margin-left: 0;
            width: 100%;
            font-size: 16px;
            padding: 6px 12px;
          }
        }

        /* Action Buttons */
        .action-buttons {
          display: flex;
          justify-content: end;
          align-items: center;
          gap: 15px;
          margin-top: 20px;
        }

        .back-btn {
          color: white;
          border: none;
          border-radius: 6px;
          padding: 10px 20px;
          font-weight: 500;
          cursor: pointer;
          transition: background-color 0.2s;
        }

        .back-btn:hover {
          background-color: #7f8c8d;
        }

        .answer-section {
          display: flex;
          align-items: center;
          gap: 10px;
        }

        .answer-label {
          font-size: 14px;
          font-weight: 600;
          color: #2c3e50;
        }

        .answer-select {
          appearance: none;
          padding: 8px 12px;
          border: 1px solid #bdc3c7;
          border-radius: 6px;
          background-color: white;
          color: #2c3e50;
          font-weight: 500;
          cursor: pointer;
          min-width: 200px;
        }

        .answer-select:focus {
          outline: none;
          border-color: #3498db;
        }

        @media (max-width: 768px) {
          .action-buttons {
            flex-direction: column;
            gap: 12px;
            align-items: stretch;
          }

          .back-btn {
            padding: 12px 16px;
            font-size: 14px;
            text-align: center;
            width: 100%;
          }

          .answer-section {
            flex-direction: column;
            gap: 8px;
            align-items: stretch;
            width: 100%;
          }

          .answer-label {
            font-size: 13px;
            text-align: center;
          }

          .answer-select {
            min-width: unset;
            width: 100%;
            padding: 10px 12px;
            font-size: 14px;
          }
        }

        /* Enhanced Leaderboard Sidebar */
        .sidebar {
          width: 400px;
        }

        .leaderboard-container {
          background: white;
          border-radius: 20px;
          box-shadow: 0 20px 40px rgba(0, 0, 0, 0.1);
          overflow: hidden;
        }

        /* Gold Banner */
        .gold-banner {
          position: relative;
          background: linear-gradient(
            135deg,
            #ff6b6b 0%,
            #ee5a24 50%,
            #ff3838 100%
          );
          padding: 30px 20px 20px;
          text-align: center;
          overflow: hidden;
        }

        .gold-banner::before {
          content: "";
          position: absolute;
          top: -50%;
          left: -50%;
          width: 200%;
          height: 200%;
          background: radial-gradient(
            circle,
            rgba(255, 255, 255, 0.1) 0%,
            transparent 70%
          );
          animation: shimmer 3s ease-in-out infinite;
        }

        @keyframes shimmer {
          0%,
          100% {
            transform: rotate(0deg);
          }
          50% {
            transform: rotate(180deg);
          }
        }

        .banner-decorations {
          position: absolute;
          top: 10px;
          width: 100%;
          display: flex;
          justify-content: space-between;
          padding: 0 20px;
        }

        .decoration {
          color: #ffd700;
          font-size: 24px;
          animation: bounce 2s ease-in-out infinite;
        }

        .decoration:nth-child(2) {
          animation-delay: 0.5s;
        }

        @keyframes bounce {
          0%,
          20%,
          50%,
          80%,
          100% {
            transform: translateY(0);
          }
          40% {
            transform: translateY(-10px);
          }
          60% {
            transform: translateY(-5px);
          }
        }

        .banner-title {
          color: #ffd700;
          font-size: 28px;
          font-weight: bold;
          text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.3);
          letter-spacing: 2px;
          position: relative;
          z-index: 1;
        }

        /* Top 3 Users */
        .top-three {
          display: flex;
          justify-content: center;
          align-items: end;
          padding: 30px 20px;
          background: linear-gradient(to bottom, #f8f9fa, #ffffff);
          gap: 10px;
        }

        .top-user {
          display: flex;
          flex-direction: column;
          align-items: center;
          position: relative;
        }

        .top-first {
          bottom: 10px;
        }

        .top-second {
          bottom: 4px;
        }

        .user-avatar {
          width: 50px;
          height: 50px;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          color: white;
          font-weight: bold;
          font-size: 18px;
          margin-bottom: 8px;
          border: 3px solid white;
          box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
        }

        .user-info {
          text-align: center;
          margin-bottom: 10px;
        }

        .user-name {
          font-size: 12px;
          font-weight: 600;
          color: #2c3e50;
          margin-bottom: 2px;
        }

        .user-location {
          font-size: 10px;
          color: #7f8c8d;
        }

        /* Shield Banners */
        .shield {
          position: relative;
          width: 90px;
          height: 120px;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          color: white;
          font-weight: bold;
          clip-path: polygon(0 0, 100% 0, 100% 70%, 50% 100%, 0 70%);
          box-shadow: 0 8px 20px rgba(0, 0, 0, 0.2);
        }

        .shield.first {
          background: linear-gradient(135deg, #e74c3c, #c0392b);
          transform: scale(1.1);
          z-index: 3;
        }

        .shield.second {
          background: linear-gradient(135deg, #9b59b6, #8e44ad);
          z-index: 2;
        }
        .shield.first::before,
        .shield.second::before,
        .shield.third::before {
          content: "";
          position: absolute;
          top: -50%;
          left: -50%;
          width: 100%;
          height: 200%;
          background: radial-gradient(
            circle,
            rgba(255, 255, 255, 0.1) 0%,
            transparent 70%
          );
          animation: shimmershield 3s ease-in-out infinite;
        }

        @keyframes shimmershield {
          0%,
          100% {
            transform: rotate(0deg);
          }
          50% {
            transform: rotate(180deg);
          }
        }

        .shield.third {
          background: linear-gradient(135deg, #3498db, #2980b9);
          z-index: 1;
        }

        .crown {
          position: absolute;
          top: -15px;
          color: #ffd700;
          font-size: 20px;
          animation: glow 2s ease-in-out infinite alternate;
        }

        @keyframes glow {
          from {
            text-shadow: 0 0 5px #ffd700, 0 0 10px #ffd700;
          }
          to {
            text-shadow: 0 0 10px #ffd700, 0 0 20px #ffd700, 0 0 30px #ffd700;
          }
        }

        .score-badge {
          background: rgba(255, 255, 255, 0.2);
          border-radius: 50%;
          padding: 3px 10px;
          margin-bottom: 8px;
          display: flex;
          align-items: center;
          font-size: 16px;
        }

        .score-badge i {
          color: #ffd700;
          margin-right: 4px;
          font-size: 10px;
        }

        .rank-number {
          font-size: 24px;
          font-weight: bold;
        }

        /* Avatar Colors */
        .avatar-purple {
          background: linear-gradient(135deg, #9b59b6, #8e44ad);
        }
        .avatar-red {
          background: linear-gradient(135deg, #e74c3c, #c0392b);
        }
        .avatar-blue {
          background: linear-gradient(135deg, #3498db, #2980b9);
        }
        .avatar-gray {
          background: linear-gradient(135deg, #95a5a6, #7f8c8d);
        }

        /* Leaderboard List */
        .leaderboard-list {
          padding: 0 20px 20px;
        }

        .leaderboard-item {
          display: flex;
          align-items: center;
          padding: 12px 0;
          border-bottom: 1px solid #ecf0f1;
          transition: all 0.3s ease;
        }

        .leaderboard-item:hover {
          background: #f8f9fa;
          transform: translateX(5px);
        }

        .leaderboard-item:last-child {
          border-bottom: none;
        }

        .rank {
          width: 30px;
          font-size: 16px;
          font-weight: bold;
          color: #2c3e50;
        }

        .list-avatar {
          width: 40px;
          height: 40px;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          color: white;
          font-weight: bold;
          margin-right: 12px;
          border: 2px solid white;
          box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
        }

        .user-details {
          flex: 1;
        }

        .list-user-name {
          font-size: 13px;
          font-weight: 600;
          color: #2c3e50;
          margin-bottom: 2px;
        }

        .list-user-location {
          font-size: 11px;
          color: #7f8c8d;
        }

        .score-container {
          display: flex;
          flex-direction: column;
          gap: 4px;
          margin-right: 10px;
        }

        .score {
          background: linear-gradient(135deg, #f39c12, #e67e22);
          color: white;
          border-radius: 15px;
          padding: 6px 11px;
          font-size: 11px;
          font-weight: bold;
          display: flex;
          align-items: center;
          box-shadow: 0 2px 8px rgba(243, 156, 18, 0.3);
        }

        .score.secondary-score {
          background: linear-gradient(135deg, #9b59b6, #8e44ad);
          padding: 4px 8px;
          font-size: 9px;
          box-shadow: 0 1px 4px rgba(155, 89, 182, 0.3);
        }

        .score i {
          margin-right: 4px;
          font-size: 10px;
        }

        .score.secondary-score i {
          font-size: 8px;
        }

        .medal {
          width: 30px;
          height: 30px;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 14px;
        }

        .medal.gold {
          background: linear-gradient(135deg, #ffd700, #ffed4e);
          color: #f39c12;
          box-shadow: 0 2px 8px rgba(255, 215, 0, 0.4);
        }

        .medal.silver {
          background: linear-gradient(135deg, #bdc3c7, #95a5a6);
          color: #7f8c8d;
          box-shadow: 0 2px 8px rgba(189, 195, 199, 0.4);
        }

        /* Pagination Styles */
        .pagination-container {
          padding: 20px;
          border-top: 1px solid #ecf0f1;
          background: #f8f9fa;
        }

        .pagination-wrapper {
          display: flex;
          justify-content: center;
          align-items: center;
          gap: 8px;
          margin-bottom: 10px;
        }

        .pagination-btn {
          background: white;
          border: 1px solid #dee2e6;
          border-radius: 6px;
          padding: 8px 12px;
          min-width: 40px;
          height: 40px;
          display: flex;
          align-items: center;
          justify-content: center;
          cursor: pointer;
          transition: all 0.2s ease;
          font-size: 14px;
          font-weight: 500;
          color: #495057;
        }

        .pagination-btn:hover:not(.disabled) {
          background: #e9ecef;
          border-color: #adb5bd;
          transform: translateY(-1px);
        }

        .pagination-btn.active {
          background: linear-gradient(135deg, #3498db, #2980b9);
          border-color: #2980b9;
          color: white;
          box-shadow: 0 2px 8px rgba(52, 152, 219, 0.3);
        }

        .pagination-btn.disabled {
          background: #f8f9fa;
          border-color: #e9ecef;
          color: #adb5bd;
          cursor: not-allowed;
        }

        .pagination-info {
          text-align: center;
          font-size: 12px;
          color: #6c757d;
          font-weight: 500;
        }

        /* Responsive */
        @media (max-width: 992px) {
          .container {
            flex-direction: column;
          }

          .main-container {
            margin-bottom: 20px;
          }

          .sidebar {
            width: 100%;
          }
        }

        @media (max-width: 768px) {
          .result-grid {
            grid-template-columns: 1fr;
          }

          .overall-score-number {
            font-size: 56px;
          }

          .top-three {
            padding: 20px 10px;
            gap: 5px;
          }

          .shield {
            width: 70px;
            height: 100px;
          }

          .banner-title {
            font-size: 24px;
          }

          .pagination-wrapper {
            gap: 4px;
          }

          .pagination-btn {
            padding: 6px 8px;
            min-width: 36px;
            height: 36px;
            font-size: 12px;
          }
        }
      `}</style>

      <div style={{ minHeight: "100vh" }} className="bg-[#f9dfe8] py-[5rem]">
        {/* Main Content */}
        <div className="container mb-10">
          <div className="main-container">
            {/* Content Area */}
            {loading ? (
              // Loading skeleton for main content
              <div className="main-content bg-[#f9dfe8] rounded-md shadow-[0_0_20px_rgba(0,0,0,0.15)] animate-pulse opacity-60">
                {/* Title skeleton */}
                <div className="space-y-4 mb-6">
                  <div className="h-8 bg-gray-300 rounded w-3/4 mx-auto" />
                  <div className="h-6 bg-gray-300 rounded w-1/2 mx-auto" />
                </div>

                {/* Info section skeleton */}
                <div className="info-section bg-[#f1c0cf] rounded-md shadow-[0_0_20px_rgba(0,0,0,0.15)] mb-6">
                  <div className="space-y-4">
                    <div className="h-5 bg-gray-300 rounded w-full" />
                    <div className="h-5 bg-gray-300 rounded w-full" />
                    <div className="h-5 bg-gray-300 rounded w-full" />
                  </div>
                </div>

                {/* Result grid skeleton */}
                <div className="result-grid mb-6">
                  {/* Overall score skeleton */}
                  <div className="overall-score-card bg-[#f1c0cf] rounded-md shadow-[0_0_20px_rgba(0,0,0,0.15)]">
                    <div className="h-6 bg-gray-300 rounded w-1/2 mx-auto mb-4" />
                    <div className="h-4 bg-gray-300 rounded w-1/3 mx-auto mb-6" />
                    <div className="h-20 bg-gray-300 rounded w-1/2 mx-auto mb-4" />
                    <div className="h-5 bg-gray-300 rounded w-1/3 mx-auto" />
                  </div>

                  {/* Subjects skeleton */}
                  <div className="subjects-section space-y-3">
                    {[...Array(2)].map((_, idx) => (
                      <div
                        key={idx}
                        className="subject-card bg-gradient-to-br from-gray-300 to-gray-400 rounded-lg p-4 flex items-center gap-4"
                      >
                        <div className="w-20 h-20 bg-gray-400 rounded-lg" />
                        <div className="flex-1 space-y-2">
                          <div className="h-5 bg-gray-400 rounded w-3/4" />
                          <div className="h-4 bg-gray-400 rounded w-1/2" />
                        </div>
                      </div>
                    ))}
                  </div>
                </div>

                {/* Button skeleton */}
                <div className="flex justify-end">
                  <div className="h-10 bg-gray-300 rounded w-36" />
                </div>
              </div>
            ) : (
              <div className="main-content bg-[#f9dfe8] rounded-md shadow-[0_0_20px_rgba(0,0,0,0.15)]">
                <h1 className="page-title font-extrabold">{getTitle()}</h1>
                <h1 className="page-title font-extrabold">{exam?.title}</h1>

                {/* Thông tin thí sinh */}
                <div className="info-section bg-[#f1c0cf] rounded-md shadow-[0_0_20px_rgba(0,0,0,0.15)]">
                  <div className="info-item">
                    <span className="info-label">Người dự thi -</span>
                    <span className="info-label-en">Candidate name:</span>
                    <span className="info-value">
                      {getUserInfo()?.fullName}
                    </span>
                  </div>
                  <div className="info-item">
                    <span className="info-label">Ngày thi -</span>
                    <span className="info-label-en">Test date:</span>
                    <span className="info-value">
                      {dayjs(new Date()).format("DD/MM/YYYY")}
                    </span>
                  </div>
                  <div className="info-item">
                    <span className="info-label">Số báo danh -</span>
                    <span className="info-label-en">Candidate ID:</span>
                    <span className="info-value">
                      {getUserInfo()?.identifier}
                    </span>
                  </div>
                </div>

                {/* Kết quả điểm */}
                <div className="result-grid">
                  {/* Điểm tổng */}
                  <div className="overall-score-card bg-[#f1c0cf] rounded-md shadow-[0_0_20px_rgba(0,0,0,0.15)]">
                    <div className="overall-score-title text-[#db3b6d]">
                      Điểm bài thi
                    </div>
                    <div className="overall-score-subtitle text-[#db3b6d]">
                      Overall score
                    </div>
                    <div className="overall-score-number text-[#db3b6d]">
                      {resultData.overallScore}
                    </div>
                    <div className="overall-score-range text-[#db3b6d]">
                      0 - {resultData.maxOverallScore}
                    </div>
                  </div>

                  {/* Chi tiết từng môn */}
                  <div className="subjects-section">
                    {/* {exam?.type === "TSA" && (
                    <div className="subjects-title">
                      Số câu đúng -{" "}
                      <span className="subjects-subtitle">
                        Correct answers:
                      </span>
                    </div>
                  )} */}

                    {resultData.subjects.map((subject) => (
                      <div
                        key={subject.id}
                        className="subject-card bg-gradient-to-br from-red-600 to-red-700"
                      >
                        <div className="subject-score">
                          <span className="subject-score-number">
                            {subject.score}
                          </span>
                          <div className="subject-score-range">
                            0 - {subject.totalQuestions}
                          </div>
                        </div>
                        <div className="subject-info">
                          <div className="subject-name">{subject.name}</div>
                          <div className="subject-name-en">
                            {subject.nameEn}
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>

                {/* Action buttons */}
                <div className="action-buttons">
                  {/* <button
                  onClick={() => navigate(`/exams?examRoomId=${examRoomId}`)}
                  className="back-btn bg-gray-300 text-gray-700"
                >
                  ← Quay lại
                </button> */}

                  {/* {isAnswer && ( */}
                  {isAnswer && (
                    <div className="answer-section">
                      <button
                        className="inline-flex items-center justify-center w-36 h-10 rounded-md text-white border border-[#e5a7b7] bg-[#db3b6d] hover:bg-[#db3b6d] hover:text-white transition-colors flex-shrink-0 ml-2"
                        onClick={() => navigate(`/exam-answer/${examId}`)}
                      >
                        <VisibilityIcon className="mr-2" /> Xem đáp án
                      </button>
                    </div>
                  )}

                  {/* )} */}
                </div>
              </div>
            )}
          </div>
        </div>
      </div>

      {/* Answer Condition Modal */}
      <AnswerConditionModal
        isOpen={showAnswerConditionModal}
        onClose={() => setShowAnswerConditionModal(false)}
        answerView={exam?.answerView}
        userScore={resultData?.overallScore}
        maxScore={resultData?.maxOverallScore}
        userRank={exam?.rank}
        isInTimeRange={isNowInRange(
          exam?.time?.startTime,
          exam?.time?.endTime,
          exam?.completedDate
        )}
        completedDate={exam?.completedDate}
        startTime={exam?.time?.startTime}
        endTime={exam?.time?.endTime}
      />
    </>
  );
};

export default ExamResultPage;
